<template>
  <div class="body_area after_bg sm">

    <div class="block-header">
      <div class="container">
        <div class="row clearfix">
          <div class="col-lg-6 col-md-12">
            <h1 class="mb-1 mt-1">리스트 추가</h1>
          </div>
        </div>
        <div class="bh_divider"></div>
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12">
            <nav class="navbar navbar-expand-lg page_menu">
              <div class="collapse navbar-collapse" id="Blog_app" style="display: block;">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item "><a href="javascript:void(0);" class="nav-link"  @click="toLeadPage">리드</a></li>
                  <li class="nav-item active"><a href="javascript:void(0);" class="nav-link"  @click="toListPage">리스트</a></li>
                </ul>
                <div>
                  <button type="button" class="btn btn-secondary" v-if="groupStatus == 0" @click="addList">생성</button>
                  <button type="button" class="btn btn-secondary" v-if="groupStatus == 1" @click="editList">수정</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>


    <div class="container">
        <!-- Input -->
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="card">
              <div class="header">
                <h2><strong>리스트명</strong> </h2>
              </div>
              <div class="body">
                <h2 class="card-inside-title">리스트명</h2>
                <div class="row clearfix">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <input type="text" class="form-control" v-model="leadGroupTitle" placeholder="이름" />
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
        <!-- #END# Input -->
      </div>
    </div>


</template>


<script>
export default {
  name: 'ListAddPage',
  components: {
  },
  data() {
    return {
      leadGroupTitle : null,
      leadGroupCode : null,
      groupStatus : 0,
    }
  },
  methods: {
    addList(){

      if(this.leadGroupTitle == null){
        alert("리스트명을 입력해주세요.")
        return;
      }

      var param = {
        leadGroupTitle : this.leadGroupTitle,
        companyCode : this.$store.getters.getUserCode

      }

      console.log(param)

      this.api.addList(param)
      .then((res)=>{

        if(this.utils.preApiHandle(res)) {
          console.log("add list res : ", res)
        }

        if(res.code == 0){
          alert("저장되었습니다.");
          this.$router.push({name:'ListListPage'})
        } else {
          alert("오류가 발생했습니다.")
        }

      })

    },
    editList(){

      var param = {
        leadGroupTitle : this.leadGroupTitle,
        leadGroupCode : this.leadGroupCode,
        companyCode : this.$store.getters.getUserCode
      }

      this.api.editList(param)
      .then((res)=>{

        if(this.utils.preApiHandle(res)) {
          console.log("list list res : ", res)
        }

        if(res.code == 0){
          alert("수정되었습니다.")
          this.$router.push({name:"ListListPage"})
        } else {
          alert("오류가 발생했습니다.")
        }

      })

    },
    toLeadPage(){
      this.$router.push({name:"LeadListPage"})
    },
    toListPage(){
      this.$router.push({name:"ListListPage"})
    },
  },
  created() {
    console.log('ListAddPage created')

    this.leadGroupCode = null;

    console.log(this.$route.params)

    if(this.$route.params.leadGroupCode != null){
      var param = {
        leadGroupCode : this.$route.params.leadGroupCode,
        companyCode : this.$store.getters.getUserCode
      }

      console.log(param)

      this.api.getListDetail(param)
      .then((res)=>{
        console.log(res)

        if(this.utils.preApiHandle(res)) {
          console.log("get list res : ", res)
        }

        if(res.code == 0){
          this.leadGroupTitle = res.list.leadGroupTitle
          this.leadGroupCode = res.list.leadGroupCode
          this.groupStatus = 1;
        } else {
          alert("오류가 발생했습니다.")
        }

      })
    }
  },
  mounted() {
    console.log('ListAddPage created')
  },
  beforeDestroy() {
    console.log('ListAddPage beforeDestroy')
  }
}
</script>

